import { createAction, createReducer } from 'redux-act';
import { useSelector } from 'react-redux';
import { BureauData } from '../../components/offers.new/types';
import type { UserPredictions } from '../../services/offers/types';

interface IState {
    calcId: string;
    bureauData: BureauData;
    userPredictions: UserPredictions;
}

const defaultState: IState = {
    calcId: '',
    bureauData: {},
    userPredictions: [],
};

/** @deprecated not used */
export const setBureau = createAction<BureauData>('set bureau');

export const setOffersData = createAction<Partial<IState>>('set offers data');

/** Данные, связанные с компонентом выдачи кредита */
export const offerReducer = createReducer({}, defaultState)
    .on(setBureau, (state, payload) => {
        return {
            ...state,
            bureauData: payload,
        };
    })
    .on(setOffersData, (state, payload) => {
        return {
            ...state,
            ...payload,
        };
    });

export const useOffers = () => useSelector((state: { offers: IState }) => state.offers);
